class JikumiCinematic {
  constructor(root) {
    this.root = root;
    this.hero = root.querySelector('.jkm-hero');
    this.heroScene = root.querySelector('.jkm-hero-scene');
    this.typeRun = root.querySelector('.jkm-type-run');
    this.campaign = root.querySelector('.jkm-campaign');
    this.edit = root.querySelector('.jkm-edit');
    this.heroCopy = root.querySelector('.jkm-hero-copy');
    this.campaignImage = root.querySelector('.jkm-campaign-image img');
    this.editImage = root.querySelector('.jkm-edit-image img');
    this.endureTitle = root.querySelector('.jkm-endure h2');
    this.values = root.querySelector('.jkm-values');
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.ticking = false;
    this.init();
  }

  init() {
    this.root.classList.add('jkm-motion-ready');
    this.addProgress();
    this.observeReveals();
    if (!this.reduced) {
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }
  }

  addProgress() {
    this.progress = document.createElement('span');
    this.progress.className = 'jkm-scroll-progress';
    this.root.prepend(this.progress);
  }

  observeReveals() {
    const targets = this.root.querySelectorAll('.jkm-manifesto > *, .jkm-head > *, .jkm-product, .jkm-category, .jkm-campaign-copy > *, .jkm-collection, .jkm-edit-copy > *, .jkm-endure > *, .jkm-value, .jkm-news > *');
    targets.forEach((item, index) => {
      item.classList.add('jkm-reveal');
      item.style.setProperty('--delay', `${Math.min(index % 4, 3) * 90}ms`);
    });
    if (this.reduced) {
      targets.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -6% 0px' });
    targets.forEach((item) => observer.observe(item));
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(() => {
      const y = window.scrollY;
      const page = document.documentElement.scrollHeight - window.innerHeight;
      this.progress.style.transform = `scaleX(${page > 0 ? Math.min(y / page, 1) : 0})`;

      if (this.hero) {
        const heroHeight = this.heroScene ? this.heroScene.offsetHeight - window.innerHeight : this.hero.offsetHeight;
        const ratio = Math.max(0, Math.min(y / (heroHeight || 1), 1));
        this.hero.style.setProperty('--hero-progress', ratio);
        this.hero.style.setProperty('--hero-y', `${ratio * 64}px`);
        if (this.heroCopy) {
          this.heroCopy.style.transform = `translate3d(0, ${ratio * 48}px, 0)`;
          this.heroCopy.style.opacity = `${Math.max(1 - ratio * 0.72, 0.18)}`;
        }
      }

      if (this.typeRun) {
        const frame = this.typeRun.getBoundingClientRect();
        this.typeRun.style.setProperty('--run-x', `${Math.max(-420, Math.min(80, frame.top * .18 - 110))}px`);
      }

      const revealMask = (element, property) => {
        if (!element) return;
        const frame = element.getBoundingClientRect();
        const progress = Math.max(0, Math.min(1, (window.innerHeight - frame.top) / (window.innerHeight * .72)));
        element.style.setProperty(property, `${(1 - progress) * 8}%`);
      };
      revealMask(this.campaign, '--campaign-mask');
      revealMask(this.edit, '--edit-mask');

      const travel = Math.max(0, Math.min(1, y / Math.max(document.documentElement.scrollHeight - window.innerHeight, 1)));
      this.root.style.setProperty('--product-shift', `${18 - travel * 14}px`);
      this.root.style.setProperty('--category-shift', `${24 - travel * 18}px`);

      if (this.campaignImage) {
        const frame = this.campaignImage.parentElement.getBoundingClientRect();
        const ratio = (window.innerHeight - frame.top) / (window.innerHeight + frame.height);
        const clamped = Math.max(0, Math.min(ratio, 1));
        this.campaignImage.style.transform = `scale(1.08) translate3d(0, ${(0.5 - clamped) * 42}px, 0)`;
      }

      if (this.editImage) {
        const frame = this.editImage.parentElement.getBoundingClientRect();
        const ratio = (window.innerHeight - frame.top) / (window.innerHeight + frame.height);
        const clamped = Math.max(0, Math.min(ratio, 1));
        this.editImage.style.transform = `scale(1.06) translate3d(0, ${(0.5 - clamped) * 38}px, 0)`;
      }

      if (this.endureTitle) {
        const frame = this.endureTitle.parentElement.getBoundingClientRect();
        const offset = Math.max(-24, Math.min(24, (window.innerHeight / 2 - frame.top - frame.height / 2) * 0.035));
        this.endureTitle.style.transform = `translate3d(${offset}px, 0, 0)`;
      }

      if (this.values) {
        const frame = this.values.getBoundingClientRect();
        const shift = Math.max(-28, Math.min(28, (window.innerHeight / 2 - frame.top) * 0.025));
        this.values.style.setProperty('--ticker-shift', `${shift}px`);
      }
      this.ticking = false;
    });
  }
}

const mountJikumiMotion = (scope = document) => {
  scope.querySelectorAll('.jkm-home:not([data-motion-mounted])').forEach((root) => {
    root.dataset.motionMounted = 'true';
    new JikumiCinematic(root);
  });
};

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mountJikumiMotion());
else mountJikumiMotion();
document.addEventListener('shopify:section:load', (event) => mountJikumiMotion(event.target));
